import { render } from "./VisitorAskUsPage.vue?vue&type=template&id=4c157f5b&scoped=true"
import script from "./VisitorAskUsPage.vue?vue&type=script&lang=js"
export * from "./VisitorAskUsPage.vue?vue&type=script&lang=js"

import "@/assets/css/globalStyle.css?vue&type=style&index=0&id=4c157f5b&scoped=true&lang=css"
import "./VisitorAskUsPage.vue?vue&type=style&index=1&id=4c157f5b&scoped=true&lang=css"

import exportComponent from "D:\\Mapua\\Mapua Submissions\\IT135-8L\\PROJECT\\WEB APP\\IT135-8L_TFYO\\tfyo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c157f5b"]])

export default __exports__